import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ShippingSchoolApp } from './components/ShippingSchoolApp';
import { ArchitectureDiagram } from './components/ArchitectureDiagram';
import { ProjectStructure } from './components/ProjectStructure';
import { SESQuest } from './components/SESQuest';
import { SESQuestReal } from './components/SESQuestReal';
import { AWSSignupWizard } from './components/AWSSignupWizard';
import { DomainManager } from './components/DomainManager';
import { IAMPermissionPalace } from './components/IAMPermissionPalace';
import { EmailSender } from './components/EmailSender';
import { ClientFolderManager } from './components/ClientFolderManager';
import { ShareAccessPortal } from './components/ShareAccessPortal';
import { FolderCreationSteps } from './components/FolderCreationSteps';
import { LinksDirectory } from './components/LinksDirectory';
import { ProjectFileExplorer } from './components/ProjectFileExplorer';

function App() {
  return (
    <Routes>
      <Route path="/" element={<ShippingSchoolApp />} />
      <Route path="/architecture" element={<ArchitectureDiagram />} />
      <Route path="/structure" element={<ProjectStructure />} />
      <Route path="/ses-quest" element={<SESQuest />} />
      <Route path="/ses-real" element={<SESQuestReal />} />
      <Route path="/aws-signup" element={<AWSSignupWizard />} />
      <Route path="/iam-setup" element={<IAMPermissionPalace />} />
      <Route path="/domains" element={<DomainManager />} />
      <Route path="/send-email" element={<EmailSender />} />
      <Route path="/files" element={<ClientFolderManager />} />
      <Route path="/share/:linkId" element={<ShareAccessPortal />} />
      <Route path="/folder-steps" element={<FolderCreationSteps />} />
      <Route path="/links" element={<LinksDirectory />} />
      <Route path="/project-files" element={<ProjectFileExplorer />} />
    </Routes>
  );
}

export default App;
